<template>
    <div class="industryData">
        <dataAnalysisTemplate
            :echoData="echoData"
            :showData="crowdPortrait"
            @save="save"
            :viewData="viewData"
        ></dataAnalysisTemplate>
    </div>
</template>

<script>
import dataAnalysisTemplate from './dataAnalysisTemplate';
import { getDataAnalysisInfo } from '../../../../utils/apis';

export default {
    name: 'industryData',
    components: {
        dataAnalysisTemplate,
    },
    data() {
        return {
            viewData: {},
            crowdPortrait: 'industryData',
            echoData: {},
        };
    },
    methods: {
        save(val) {
            // val.name = 'industryData'
            // this.$emit('save', val)
            // sessionStorage.setItem('industryData', JSON.stringify(val))
            this.$emit('save', 4, val);
        },
        async getDataAnalysisInfoFn() {
            let res = await getDataAnalysisInfo({
                type: 4,
            });
            this.echoData = res.data;
        },
    },
    mounted() {
        this.getDataAnalysisInfoFn();
    },
};
</script>

<style scoped>
.industryData {
    width: 100%;
    height: 100%;
}
</style>
